<template>
	<div>
		  <Breadcrumbs main="Work Management" title="Update Work" />
			 <div class="container-fluid">
				<div class="row">
				   <div class="col-sm-12">
					  <div class="card">
						 <div class="card-body">
 
							<div class="row mb-3">
							   	<div class="col-12">
									<a href="#" @click.prevent="handleGoBack" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</a>
									<span v-if="from_enquiry_list" class="badge bg-success fs-6 float-start mt-2">Converting from Enquiry</span>
							   	</div>
							</div>
 
							<form  @submit.prevent="updateWork" enctype="multipart/form-data">
								<div class="form theme-form">

									

									<!-- <div class="col-md-3 mt-3" v-if="showEnquiry">
											<div class="form-check mt-4">
												<input class="form-check-input" type="checkbox" id="is_enquiry" v-model="is_enquiry"/>
												<label class="form-check-label" for="is_enquiry">This job is an enquiry</label>
												<span class="validate-error" v-if="errors.is_enquiry">
													{{ errors.is_enquiry[0] }}
												</span>
											</div>
										</div> -->

									<div class="row">
										<div class="col-md-12 mb-4" v-if="showEnquiry">
											<div class="form-check mt-4">
												<input class="form-check-input" type="checkbox" id="is_enquiry" v-model="is_enquiry"/>
												<label class="form-check-label fw-bold" for="is_enquiry">
													This job is an enquiry
												</label>
											</div>
											<span class="validate-error" v-if="errors.is_enquiry">
												{{ errors.is_enquiry[0] }}
											</span>
										</div>
									</div>
									
									<div class="row">
										<div class="col-md-3">
											<div class="mb-3">
												<label class="control-label">Product<span class="text-danger">*</span></label>
												<select class="form-select" v-model="job.product_id">
													<option value="">Select</option>
													<option v-for="product in products" :value="product.id">{{ product.product_name }}</option>
												</select>
											</div>
										</div>

                                        <div class="col-md-3 form-group">
                                            <label class="control-label">Work Type<span class="text-danger">*</span></label>
                                            <select class="form-select" v-model="job.service_type">
												<option value="">Select</option>
												<option value="1">New</option>
												<option value="2">Repair</option>
												<option value="3">Replacement</option>
											</select>
                                        </div>

										<div class="col-md-3" v-if="job.service_type == '2' || job.service_type == '3'">
											<div class="mb-3">
												<label class="control-label">Select IMEI<span class="text-danger">*</span></label>
												<input class="form-control" type="text" placeholder="Search IMEI or Vehicle No" v-model="device_imei" @input="fetchDevices" @focus="showSuggestions = true"/>
												<ul
													v-if="showSuggestions && devices.length"
													class="list-group position-absolute w-100"
													style="z-index: 9999; max-height: 200px; overflow-y: auto;"
												>
													<li
													v-for="device in devices"
													:key="device.imei"
													class="list-group-item list-group-item-action"
													@mousedown.prevent="setImei(device)"
													>
													{{ device.vehicle_no + ' - ' + device.imei }}
													</li>
												</ul>
												<span class="validate-error" v-if="errors.device_id">
													{{ errors.device_id[0] }}
												</span>
											</div>
										</div>

										<div class="col-md-3">
											<div class="mb-3">
												<label class="control-label">Select RTO<span class="text-danger">*</span></label>
												<input class="form-control" type="text" placeholder="Search RTO" v-model="rto_search" @input="handleRtoSearch" @focus="showRtoSuggestions = true" @blur="handleRtoInputBlur" v-bind:class="{ 'is-invalid': Boolean(errors.rto_id) }"/>
												<ul
													v-if="showRtoSuggestions && filteredRtoList.length" class="list-group position-absolute"
													style="width:93%; z-index: 9999; max-height: 200px; overflow-y: auto;"
													ref="rtoSuggestionList"
												>
													<li v-for="rto in filteredRtoList" :key="rto.id" class="list-group-item list-group-item-action" @mousedown.prevent="setRto(rto)">
														{{ rto.rto_code }} - {{ rto.rto_name }}
													</li>
												</ul>
												<span class="validate-error" v-if="errors.rto_id">
													{{ errors.rto_id[0] }}
												</span>
											</div>
										</div>
									</div>

									<div class="row">
										<div class="col-md-3">
											<div class="mb-3">
												<label class="control-label">Customer Name<span class="text-danger">*</span></label>
												<input class="form-control" type="text" placeholder="Enter Customer Name" v-model="job.customer_name"/>
											</div>
										</div>

                                        <div class="col-md-3 form-group">
                                            <label class="control-label">Mobile No.<span class="text-danger">*</span></label>
                                            <input class="form-control" type="text" placeholder="Enter Customer Mobile" v-model="job.mobile" @input="restrictMobileInput" maxlength="10" minlength="10"/>
                                        </div>

										<div class="col-md-3 form-group">
                                            <label class="control-label">Vehicle Type.<span class="text-danger">*</span></label>
                                            <select class="form-select" v-model="job.vehicle_type">
												<option value="">Select Vehicle Type</option>
												<option v-for="type in vehicle_types" :value="type.id">{{ type.name }}</option>
											</select>
											<span class="validate-error" v-if="errors.vehicle_type">
												{{ errors.vehicle_type[0] }}
											</span>
                                        </div>

										<div class="col-md-3 form-group">
                                            <label class="control-label">Vehicle No.<span class="text-danger">*</span></label>
                                            <input class="form-control" type="text" placeholder="Enter Vehicle Number" v-model="job.vehicle_no"/>
											<span class="validate-error" v-if="errors.vehicle_no">
												{{ errors.vehicle_no[0] }}
											</span>
                                        </div>

										<div class="col-md-12">
											<div class="mb-3">
												<label class="control-label">Location<span class="text-danger">*</span></label>
												<GMapAutocomplete 
													@place_changed="setPlace" class="form-control" 
													placeholder="Search here to pick the required latitude and longitude..."
													:value="job.location">
												</GMapAutocomplete>

												<GMapMap v-if="center.lat && center.lng"
													:center="center"
													:zoom="18"
													map-style-id="roadmap"
													:options="mapOptions"
													style="width: 100%; height: 30vmin"
													ref="mapRef"
													@click="handleMapClick">
														<GMapMarker v-if="marker.position.lat && marker.position.lng"
															:position="marker.position"
															:clickable="true"
															:draggable="true"
															@drag="handleMarkerDrag"
															@click="panToMarker"
														/>
												</GMapMap > 
												<span class="validate-error" v-if="errors.location">
													{{ errors.location[0] }}
												</span>
											</div>
										</div>

                                        <div class="col-md-6">
											<div class="mb-3">
												<label class="control-label">Latitude<span class="text-danger">*</span></label>
												<input v-model="marker.position.lat" class="form-control" type="text" v-bind:class="{ 'is-invalid': Boolean(errors.latitude) }" minlength="3" maxlength="100" disabled/>
												<span class="validate-error" v-if="errors.latitude">
													{{ errors.latitude[0] }}
												</span>
											</div>
										</div>
										<div class="col-md-6">
											<div class="mb-3">
												<label class="control-label">Longitude<span class="text-danger">*</span></label>
                                                <input v-model="marker.position.lng" type="text" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.longitude) }" minlength="3" maxlength="100" disabled/>
												<span class="validate-error" v-if="errors.longitude">
													{{ errors.longitude[0] }}
												</span>
											</div>
										</div>

										<div class="col-md-3">
											<div class="mb-3">
												<label class="control-label">Technician<span class="text-danger">*</span></label>
												<select class="form-select" v-model="job.technician_id">
													<option value="">Select Technician</option>
													<option v-for="technician in technicians" :value="technician.id">{{ technician.name }}</option>
												</select>
												<span class="validate-error" v-if="errors.technician_id">
													{{ errors.technician_id[0] }}
												</span>
											</div>
										</div>

										<div class="col-md-3">
											<div class="mb-3">
												<label class="control-label">Amount<span class="text-danger">*</span></label>
												<input class="form-control" type="text" placeholder="" v-model="job.total_amount"/>
												<span class="validate-error" v-if="errors.amount">
													{{ errors.amount[0] }}
												</span>
											</div>
										</div>

										<div class="col-md-3">
											<div class="mb-3">
												<label class="control-label">Date<span class="text-danger">*</span></label>
												<input class="form-control" type="date" placeholder="" v-model="date" v-bind:class="{ 'is-invalid': Boolean(errors.date) }" :min="min" :max="max"/>
												<span class="validate-error" v-if="errors.date">
													{{ errors.date[0] }}
												</span>
											</div>
										</div>

									</div>
									<div class="row mt-3">
										<div class="col-sm-12">
											<button class="btn btn-success me-2 float-end" type="submit">Save</button>
										</div>
									</div>
	
								</div>
							</form>
						 </div>
					  </div>
				   </div>
				</div>
			 </div>
 
	</div>
 </template>

<script setup>
	import { post, get } from '@/utils/api';
	import { routes } from '@/constants/routes';
	import { ref, onMounted, watch, computed } from 'vue';
	import { useRoute, useRouter } from 'vue-router';
	// import Swal from 'sweetalert2';
	import Swal from '@/utils/swal';
	import { goBack } from '@/utils/urlHider';
	
	const now = new Date();
	const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
	// Format date as YYYY-MM-DD for date input using local timezone
	const year = today.getFullYear();
	const month = String(today.getMonth() + 1).padStart(2, '0');
	const day = String(today.getDate()).padStart(2, '0');
	const todayFormatted = `${year}-${month}-${day}`;

	const router = useRouter();
	const route = useRoute();

	const products = ref([]);
	const job = ref({});
	const job_id = route.query.id;
	const from_enquiry_list = route.query.from === 'enquiry_list';
	const technicians = ref({});
	const amount = ref("");
	const is_enquiry = ref(false); 
	const device_imei = ref("");
	const devices = ref([]);
	const showSuggestions = ref(false);
	const device_id = ref("");
	const vehicle_types = ref([]);
	const errors = ref({});
	const showEnquiry = ref(false);
	const date = ref("");
	const min = "";
	const max = todayFormatted;

	// RTO dropdown variables
	const rto_list = ref([]);
	const rto_id = ref("");
	const rto_search = ref("");
	const showRtoSuggestions = ref(false);
	const rtoSuggestionList = ref(null);

	const mapRef = ref(null);

	const marker = ref({
		position: { lat: null, lng: null }
	});

	const center = ref({
		lat: null,
		lng: null
	});

	const current_place = ref(null);

	const mapOptions = {
		disableDefaultUI: true,
	};

	// Computed property for filtered RTO list
	const filteredRtoList = computed(() => {
		if (!rto_search.value || rto_search.value.trim() === '') {
			return rto_list.value;
		}
		const searchTerm = rto_search.value.toLowerCase();
		return rto_list.value.filter(rto => 
			rto.rto_code.toLowerCase().includes(searchTerm) || 
			rto.rto_name.toLowerCase().includes(searchTerm)
		);
	});

	// Methods
	const geolocate = () => {
		navigator.geolocation.getCurrentPosition((position) => {
			marker.value.position = {
				lat: position.coords.latitude,
				lng: position.coords.longitude,
			};
			panToMarker();
		});
	};

	const handleMarkerDrag = (e) => {
		marker.value.position = {
			lat: e.latLng.lat(),
			lng: e.latLng.lng(),
		};
	};

	const panToMarker = () => {
		mapRef.value?.panTo(marker.value.position);
	};

	const handleMapClick = (e) => {
		marker.value.position = {
			lat: e.latLng.lat(),
			lng: e.latLng.lng(),
		};
		console.log(e);
	};

	const setPlace = (place) => {
		current_place.value = place;

		if (current_place.value) {
			const markerPos = {
				lat: current_place.value.geometry.location.lat(),
				lng: current_place.value.geometry.location.lng(),
			};

			center.value = markerPos;
			marker.value.position = markerPos;

			job.value.location = place.formatted_address;
			job.value.latitude = markerPos.lat;
			job.value.longitude = markerPos.lng;
		}
	};

	const restrictMobileInput = (event) => {
		// Remove any non-digit characters and limit to 10 digits
		const value = event.target.value.replace(/\D/g, '').slice(0, 10);
		job.value.mobile = value;
	};

	const fetchJob = () => {

		const params = {
			job_id: job_id
		}

		get(routes.JobDetail, { params }, false)
			.then((response) => {
				if(response.status === 200){
					console.log(response.data.data);
					job.value = response.data.data.details;
					
					if (job.value.latitude && job.value.longitude) {
						marker.value.position.lat = parseFloat(job.value.latitude);
						marker.value.position.lng = parseFloat(job.value.longitude);
						center.value.lat = parseFloat(job.value.latitude);
						center.value.lng = parseFloat(job.value.longitude);
					}

					is_enquiry.value = job.value.is_enquiry == 1;
					if(job.value.is_enquiry == 1){
						showEnquiry.value = true;
					}
					if (job.value.device_id != null) {
						const device = devices.value.find(u => u.id == job.value.device_id);
						if (device) {
							setImei(device);
						}
					}
					
					// Auto-fill IMEI field based on product type
					// For GPS products (product_id == 1): use IMEI
					// For other products: use vehicle_no
					if (job.value.product_id == 1 || job.value.product_id == '1') {
						// GPS product - auto-fill with IMEI
						if (job.value.imei) {
							device_imei.value = job.value.imei;
						}
					} else {
						// Other products - auto-fill with vehicle_no
						if (job.value.vehicle_no) {
							device_imei.value = job.value.vehicle_no;
						}
					}
					
					// Set date from job data
					if (job.value.date) {
						date.value = job.value.date;
					}
					
					if(job.value.technician_id == null){
						job.value.technician_id = "";
					}
					if(job.value.vehicle_type == null){
						job.value.vehicle_type = "";
					}

					// Pre-select RTO after job data is loaded
					preSelectRTO();

				} else {
					Swal.fire('', response.data.message || 'Failed to fetch job', 'error');
				}
			})
			.catch((error)  => {
				if (error.response?.status === 422) {
					Swal.fire('', error.response.data.message.job_id?.[0] || 'Validation error', 'error');
				} else if (error.response?.status === 500) {
					Swal.fire('', error.response.statusText || 'Server error', 'error');
				} else if (error.response?.status === 401) {
					Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
					router.push({ name: 'login' });
				} else {
					Swal.fire('', error.response.data?.message || 'Error occured', 'error');
				}
			});
	};

	const fetchProducts = () => {

		get(routes.AllProducts, {}, false)
			.then((response) => {
				if (response.status === 200) {
					// console.log(response.data.data);
					products.value = response.data.data;
				} else {
					Swal.fire('', response.data.message || 'Error fetching data', 'error');
				}
			})
			.catch((error) => {
				if (error.response?.status === 422) {
					Swal.fire('', 'Validation error', 'error');
				} else if (error.response?.status === 500) {
					Swal.fire('', error.response.statusText || 'Server error', 'error');
				} else if (error.response?.status === 401) {
					Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
					router.push({ name: 'login' });
				} else {
					Swal.fire('', error.response.data?.message || 'Error occured', 'error');
				}
			});
	};

	const fetchTechnicians = () => {

		get(routes.AllTechnicians, {}, false)
			.then((response) => {
				if (response.status === 200) {
					// console.log(response.data.data);
					technicians.value = response.data.data;
				} else {
					Swal.fire('', response.data.message || 'Error fetching data', 'error');
				}
			})
			.catch((error) => {
				if (error.response?.status === 422) {
					Swal.fire('', 'Validation error', 'error');
				} else if (error.response?.status === 500) {
					Swal.fire('', error.response.statusText || 'Server error', 'error');
				} else if (error.response?.status === 401) {
					Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
					router.push({ name: 'login' });
				} else {
					Swal.fire('', error.response.data?.message || 'Error occured', 'error');
				}
			});
	};

	const fetchDevices = () => {

		const params = {
			keyword: device_imei.value
		}

		get(routes.AllDevices, { params }, false)
			.then((response) => {
				if (response.status === 200) {
					// console.log(response.data.data);
					devices.value = response.data.data;
				} else {
					Swal.fire('', response.data.message || 'Error fetching data', 'error');
				}
			})
			.catch((error) => {
				if (error.response?.status === 422) {
					Swal.fire('', 'Validation error', 'error');
				} else if (error.response?.status === 500) {
					Swal.fire('', error.response.statusText || 'Server error', 'error');
				} else if (error.response?.status === 401) {
					Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
					router.push({ name: 'login' });
				} else {
					Swal.fire('', error.response.data?.message || 'Error occured', 'error');
				}
			});
	};

	const fetchVehicleTypes = () => {

		get(routes.VehicleTypes, {}, false)
			.then((response) => {
				if (response.status === 200) {
					// console.log(response.data.data);
					vehicle_types.value = response.data.data;
				} else {
					Swal.fire('', response.data.message || 'Error fetching data', 'error');
				}
			})
			.catch((error) => {
				if (error.response?.status === 422) {
					Swal.fire('', 'Validation error', 'error');
				} else if (error.response?.status === 500) {
					Swal.fire('', error.response.statusText || 'Server error', 'error');
				} else if (error.response?.status === 401) {
					Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
					router.push({ name: 'login' });
				} else {
					Swal.fire('', error.response.data?.message || 'Error occured', 'error');
				}
			});
	};

	const fetchRTOList = () => {

		get(routes.RTOList, {}, false)
			.then((response) => {
				if (response.status === 200) {
					// console.log(response.data.data);
					rto_list.value = response.data.data;
				}
			})
			.catch((error) => {
				if (error.response?.status === 422) {
					Swal.fire('Validation Error', 'Please check your input data', 'error');
				} else if (error.response?.status === 500) {
					Swal.fire('Server Error', error.response.statusText || 'Server error occurred', 'error');
				}
				else if (error.response?.status === 401) {
					Swal.fire('Unauthorized', error.response.statusText || 'Please login again', 'error');
					router.push({ name: 'login' });
				} else {
					Swal.fire('Error', error.response.data?.message || 'An error occurred', 'error');
				}
			});
	};

	const updateWork = () => {

		const formData = new FormData();
		formData.append('job_id', job_id);
		formData.append('product_id', job.value.product_id);
		formData.append('work_type', job.value.service_type);
		formData.append('device_id', device_id.value);
		formData.append('customer_name', job.value.customer_name);
		formData.append('vehicle_no', job.value.vehicle_no);
		formData.append('vehicle_type', job.value.vehicle_type);
		formData.append('mobile', job.value.mobile);
		formData.append('date', date.value);
		formData.append('location', job.value.location);
		formData.append('latitude', job.value.latitude);
		formData.append('longitude', job.value.longitude);
		if(showEnquiry.value){
			formData.append('is_enquiry', +is_enquiry.value);
		}
		if(from_enquiry_list){
			formData.append('enquiry_converted', 1);
		} else {
			formData.append('enquiry_converted', '');
		}
		formData.append('technician_id', job.value.technician_id);
		if(job.value.total_amount != null){
			formData.append('amount', job.value.total_amount);
		} else {
			formData.append('amount', '');
		}
		formData.append('rto_id', rto_id.value);

		post(routes.UpdateWork, formData, false)
			.then((response) => {
				if (response.status === 200) {
					Swal.fire('', response.data.message || 'Work added successfully', 'success');
					router.push({ name: 'job_management'});
				} else {
					Swal.fire('', response.data.message || 'Failed to add work', 'error');
				}
			})
			.catch((error) => {
				if (error.response?.status === 422) {
					errors.value = error.response.data.message;
				} else if (error.response?.status === 500) {
					Swal.fire('', error.response.statusText || 'Server error', 'error');
				} else if (error.response?.status === 401) {
					Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
					router.push({ name: 'login' });
				} else {
					Swal.fire('', error.response.data?.message || 'Error occured', 'error');
				}
			});

	};

	const setImei = (device) => {
		device_imei.value = device.imei || '';
		device_id.value = device.id;
		// Use vehicle_no from AllDevices API to update the job.vehicle_no field
		if (device.vehicle_no) {
			job.value.vehicle_no = device.vehicle_no;
		}
		// Also update mobile if available
		if (device.mobile) {
			job.value.mobile = device.mobile;
		}
		console.log('Device selected from AllDevices:', device);
		showSuggestions.value = false;
	};

	// RTO dropdown handlers
	const handleRtoSearch = () => {
		if (rto_search.value && rto_search.value.trim() !== '') {
			showRtoSuggestions.value = true;
		} else {
			showRtoSuggestions.value = false;
			// Clear RTO ID if search is cleared
			if (!rto_search.value || rto_search.value.trim() === '') {
				rto_id.value = '';
			}
		}
	};

	const handleRtoInputBlur = () => {
		setTimeout(() => {
			showRtoSuggestions.value = false;
		}, 200);
	};

	const setRto = (rto) => {
		rto_search.value = `${rto.rto_code} - ${rto.rto_name}`;
		rto_id.value = rto.id;
		showRtoSuggestions.value = false;
	};

	// Clear RTO field
	const clearRtoField = () => {
		rto_search.value = '';
		rto_id.value = '';
		showRtoSuggestions.value = false;
	};

	// Pre-select RTO based on job data
	const preSelectRTO = () => {
		
		if (job.value.rto_id != null && rto_list.value.length > 0) {
			const rto = rto_list.value.find(r => r.id == job.value.rto_id);
			if (rto) {
				rto_search.value = `${rto.rto_code} - ${rto.rto_name}`;
				rto_id.value = rto.id;
			} else {
				console.log('RTO not found for ID:', job.value.rto_id);
			}
		} else {
			console.log('No RTO ID or RTO list not loaded yet');
		}
	};


	let geocoder = null

	watch(() => job.value.location, async (newVal, oldVal) => {
	if (!newVal || newVal === oldVal) return

	if (!window.google?.maps) {
		console.error('Google Maps not loaded')
		return
	}

	if (!geocoder) {
		geocoder = new window.google.maps.Geocoder()
	}

	geocoder.geocode({ address: newVal }, (results, status) => {
		if (status === 'OK' && results[0]) {
		const loc = results[0].geometry.location
		job.value.latitude = loc.lat()
		job.value.longitude = loc.lng()
		} else {
		console.warn('Geocode failed:', status)
		}
	})
	}, { immediate: false }) // ← only watch after first change

	onMounted(() => {
		fetchDevices();	
		fetchRTOList();
		fetchJob();
		fetchProducts();
		fetchTechnicians();
		fetchVehicleTypes();
	});

	const handleGoBack = () => {
		const success = goBack(router);
		if (!success) {
			// If no history, go to dashboard as fallback
			router.push({ name: 'defaultRoot' });
		}
	};

</script>